import _ from 'lodash'
import CodiceFiscale from './elementi/codiceFiscale'
import PartitaIva from './elementi/partitaIva'

export const validazioni = {
  data: (vm) => ({
    rules: {
      required: value => !!value || value === 0 || 'Campo richiesto.',
      counter: value => value && (value.length <= vm.item.maxlength) || `Max ${vm.item.maxlength} caratteri`,
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return !value || pattern.test(value) || 'E-mail non valida.'
      },
      nospaces: value => (value || '').indexOf(' ') < 0 || 'Gli spazi non sono ammessi',
      partitaiva: value => !value || !PartitaIva.validate(value) || 'Partita iva non valida',
      codicefiscale: value => !value || !CodiceFiscale.validate(value) || 'Codice fiscale non valido',
      numero: value => !value || !isNaN(value) || 'Il valore deve essere numerico',
      numeropositivo: value => !value || !isNaN(value) && (value > 0) || 'Il valore deve essere un numero positivo',
      numeropositivonullo: value => !value || !isNaN(value) && (value >= 0) || 'Il valore deve essere un numero maggiore o uguale zero',
      codicesdi: value => !value || (value.length == 7 && !_.get(vm, 'appoggio.amministrativi.isPa') || value.length == 6 && _.get(vm, 'appoggio.amministrativi.isPa')) || (_.get(vm, 'appoggio.amministrativi.isPa') ? 'Il codice deve essere di 6 caratteri alfanumerici' : 'Il codice deve essere di 7 caratteri alfanumerici'),
      setristretto: value => {
        const pattern = /^[a-zA-Z0-9_-]*$/
        return pattern.test(value) || 'Caratteri non validi (usare: 0-9a-zA-Z-_)'
      },
      setdescrizione: value => { // Non deve prendere le lettere accentate perchè la stampante non le riconosce
        const pattern = /^[a-zA-Z0-9_-][^èéòàùì]*$/
        return pattern.test(value) || 'Sono presenti alcuni caratteri non ammessi'
      }      
    }
  }),
  computed: {
    rulesValidation() {
      let rl = []
      if (this.item.required) {
        rl.push(this.rules.required)
      }
      if (this.item.isEmail) {
        rl.push(this.rules.email)
      }
      if (this.item.maxlength) {
        rl.push(this.rules.counter)
      }
      if (this.item.nospaces) {
        rl.push(this.rules.nospaces)
      }
      if (this.item.partitaiva) {
        rl.push(this.rules.partitaiva)
      }
      if (this.item.codicefiscale) {
        rl.push(this.rules.codicefiscale)
      }
      if (this.item.numerico) {
        rl.push(this.rules.numero)
      }
      if (this.item.setristretto) {
        rl.push(this.rules.setristretto)
      }
      if (this.item.codicesdi) {
        rl.push(this.rules.codicesdi)
      }
      if (this.item.setdescrizione) {
        rl.push(this.rules.setdescrizione)
      }
      return rl
    }
  }
}